import { Grid, Box, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import MenuListComponent, { ContextMenuKey, MenuListItem } from './menu-list/menu-list-component';
import { CourseDetail, CourseGroup, FirstMenu, MenuDish } from '../../models';
import Card from './Card';
import MenuDishList from './menu-dish-list/menu-dish-list';
import { apiManage_rbp } from '../../request';
import DialogComponent from '../../component/dialog/dialog.component';
import i18n from '../../i18n';
import { FormControlLabel, Switch, SwitchProps } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import GlobalNotification from '../../component/common/snackbar';
import CommonInput from '../../component/form/common-input.component';
import { MUIDataTableColumnDef } from 'mui-datatables';
import AlertDialog from '../../component/dialog/alert-dialog.component';
import Table from '../../component/table/table';
import ButtonComponent from '../../component/button/button.component';
import setLoading from '../../component/linear-determinate';

/**
 * Switch
 * @param props
 * @returns
 */
export function SwitchComponent(props: {
    value?: boolean;
    onChange?: SwitchProps['onChange'];
    label?: string;
    labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
}) {
    const { value, onChange, label, labelPlacement } = props;
    return (
        <FormControlLabel
            style={{ marginLeft: 0 }}
            control={
                <Switch
                    checked={value}
                    onChange={onChange}
                    color='primary'
                />
            }
            label={label}
            labelPlacement={labelPlacement}
        />
    );
}


export default class DishGroupDetail extends React.Component<Props, State> {
    public state: State = {
        // 套餐区域数据
        courseGroup: [],
        // 套餐区域源数据
        courseGroupSource: [],
        // 当前选择的详情index
        activeMenuIndex: '[0]',
        // 菜品弹窗 0-关闭，1-新增 2-复制套餐组 3-转移套餐组
        isDishDialogOpen: 0,
        // 加载中
        isLoading: false,
        // 删除确认框
        deleteOpen: false,
        // 套餐详情选中的菜品id
        deleteDishes: [],
        // 删除套餐区域详情菜品的删除确认框
        deleteDishesDialogOpen: false,
        // 表格显示行数
        rowsPerPage: 20,
        // 当前页
        currPage: 0,
        // 当前选中的菜品item
        rowsSelected: [],
        // 待操作的套餐区域
        handleCourseGroup: {}
    }
    // *********************
    // Life Cycle Function
    // *********************
    async componentDidMount() {
        await this.init()
    }

    // *********************
    // Default Function
    // *********************

    async init() {
        try {
            setLoading(true)
            const { dishDetail } = this.props;
            // 获取套餐组
            const result = await apiManage_rbp.get_dish_course_by_id(dishDetail.item_id as number);
            // 获取当前菜单的套餐组
            // 请求成功
            if (!_.get(result, 'error')) {
                // 获取当前菜单的套餐组
                let courseGroup: CourseGroup[] = [];
                // 请求成功
                if (!_.get(result, 'error')) {
                    // 获取当前菜单的套餐组
                    courseGroup = result.filter((item: any) => item.menu_item_id === dishDetail.item_id);
                }
                // 没有套餐组
                if (courseGroup.length === 0) {
                    const params: CourseGroup[] = [
                        {
                            course_group_id: 0,
                            // 所属菜品id
                            menu_item_id: dishDetail.item_id,
                            // 套餐组名称
                            course_group_name: i18n.t('menu_and_dishes_page_required_group'),
                            //  是否必选
                            is_must: 1,
                            //  必选数量
                            choose_num: 1
                        },
                        {
                            course_group_id: 1,
                            // 所属菜品id
                            menu_item_id: dishDetail.item_id,
                            // 套餐组名称
                            course_group_name: i18n.t('menu_and_dishes_page_option_group'),
                            //  是否必选
                            is_must: 0,
                            //  必选数量
                            choose_num: 1
                        }
                    ]
                    // 创建套餐
                    for (const i in params) {
                        if (params[i]) {
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            const { course_group_id, menu_item_id, ...otherParams } = params[i];
                            const result = await apiManage_rbp.post_course_group(dishDetail.item_id as number, otherParams)
                            if (!_.get(result, 'error')) {
                                params[i].course_group_id = result.insertId;
                            }
                        }
                    }
                    courseGroup = params;
                }
                this.setState({
                    courseGroup: _.cloneDeep(courseGroup),
                    courseGroupSource: _.cloneDeep(courseGroup)
                })
            }
        } finally {
            setLoading(false)
        }
    }

    /**
     * 点击菜单
     * @param menuData
     * @param index
     */
    handleClick(menuData: MenuListItem, index: string) {
        this.setState({
            activeMenuIndex: index,
            courseGroup: _.cloneDeep(this.state.courseGroup),
            detailIndex: undefined
        })
    }

    /**
     * 右键点击事件处理
     * @param menu
     * @param index
     * @param key
     */
    handleMenuClick(key: ContextMenuKey, menu: MenuListItem, index: number) {
        switch (key) {
            // 新增同级
            case 'ADD': {
                this.handleAddMenu()
                return;
            }
            // 删除同级
            case 'DELETE': {
                this.handleDeleteMenu({
                    id: Number(menu.dataSource.course_group_id),
                    index,
                })
                return;
            }
            // 复制套餐组
            case 'COPY_CAMBOGROUP': {
                this.setState({
                    handleCourseGroup: menu.dataSource,
                    isDishDialogOpen: 2,
                })
                return;
            }
            // 移动套餐组
            case 'TRANSFER_CAMBOGROUP': {
                this.setState({
                    handleCourseGroup: menu.dataSource,
                    isDishDialogOpen: 3,
                })
                return
            }

        }
    }

    /**
     * 新增套餐组
     */
    async handleAddMenu() {
        const { dishDetail } = this.props;
        const { courseGroup } = this.state;
        const newCourseGroup: CourseGroup = {
            course_group_id: Number(_.last(courseGroup)?.menu_item_id) + 1,
            // 所属菜品id
            menu_item_id: dishDetail.item_id,
            // 套餐组名称
            course_group_name: i18n.t('menu_and_dishes_page_option_group'),
            //  是否必选
            is_must: 0,
            //  必选数量
            choose_num: 1
        }
        const result = await apiManage_rbp.post_course_group(dishDetail.item_id as number, newCourseGroup);
        // 请求成功
        if (!_.get(result, 'error')) {
            newCourseGroup.course_group_id = result.insertId;
            courseGroup.push(newCourseGroup)
        }
        else {
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        }

        this.setState({
            courseGroup,
            courseGroupSource: _.cloneDeep(courseGroup)
        })

    }

    /**
     * 删除提示框
     */
    async handleDeleteMenu(deleteItem: State['deleteItem']) {
        this.setState({
            deleteOpen: true,
            deleteItem
        })
    }

    /**
     * 删除套餐组
     */
    async handleDelete() {
        const { dishDetail } = this.props;
        // eslint-disable-next-line prefer-const
        let { courseGroup, deleteItem, activeMenuIndex } = this.state;
        if (deleteItem) {
            // 有套餐id
            if ((dishDetail.item_id || dishDetail.item_id === 0) && dishDetail.item_type === 3) {
                const result = await apiManage_rbp.delete_course_group([deleteItem.id]);
                // 请求成功
                if (!_.get(result, 'error')) {
                    courseGroup.splice(deleteItem.index, 1)
                }
            }
            // 没有套餐id
            else {
                courseGroup.splice(deleteItem.index, 1)
            }
            // 删除的是当前选中的id
            if (activeMenuIndex === `[${deleteItem.index}]`) {
                activeMenuIndex = '[0]'
            }
            this.setState({
                courseGroup,
                courseGroupSource: _.cloneDeep(courseGroup),
                activeMenuIndex,
            })
        }

    }

    /**
     * 表单修改
     * @param value
     * @param key
     */
    onChange(value: string | number, key: string, originKey: string, detail?: CourseGroup) {
        const { courseGroup } = this.state;
        let newValue = value;
        // 价格做处理
        if (originKey === 'choose_num' || originKey === 'num') {
            if (value && Number(value) < 0) {
                newValue = 0
            }
            else if (value) {
                newValue = Number(Number(value).toFixed(0))
            }
            // 必选时, 可选数量需大于等于1
            if (originKey === 'choose_num' && detail && detail.is_must && Number(newValue) < 1) {
                newValue = 1
            }
        }
        // 数量做处理
        if (originKey === 'price' || originKey === 'rule_lnr_max_num') {
            if (value && Number(value) < 0) {
                newValue = 0
            }
            else if (value) {
                newValue = originKey === 'rule_lnr_max_num' ? Number(Number(value).toFixed(0)) : Number(Number(value).toFixed(2))
            }
        }
        // 必选时, 可选数量需大于等于1
        if (originKey === 'is_must' && value === 1 && detail && Number(detail.choose_num) < 1) {
            detail.choose_num = 1
        }
        _.set(courseGroup, key, newValue)
        this.setState({
            courseGroup,
        })
    }

    /**
     * 新增区域详情
     * @param dish
     */
    async addDish(dish: MenuDish[]) {
        const { activeMenuIndex, courseGroup } = this.state;
        // 套餐区域
        const activeMenu: CourseGroup | undefined = activeMenuIndex ? _.get(courseGroup, activeMenuIndex) : undefined;
        // 套餐区域详情
        let courseDetail = activeMenu?.course_detail || [];
        // 新添加的菜品
        const newItems: CourseDetail[] = dish.map((item) => ({
            item_name1: item.item_name1,
            menu_item_id: item.item_id,
            item_course_name: item.item_name1 || '',
            unit: item.unit_1 || '',
            num: 1,
            price: 0,
            description: '',
            rule_lnr_max_num: 9999,
        }));

        const params = newItems.map((item) => ({
            ...item,
            item_name1: undefined
        }))
        const result = await apiManage_rbp.post_course_detail(activeMenu?.course_group_id as number, params);
        // 请求成功
        if (!_.get(result, 'error')) {
            newItems.forEach((item, index, array) => {
                item.detail_id = result.insertId - (array.length - index - 1)
            })
            courseDetail = _.concat(courseDetail, newItems)
            _.set(courseGroup, `${activeMenuIndex}.course_detail`, courseDetail)
        }
        else {
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        }

        this.setState({
            courseGroup,
            courseGroupSource: _.cloneDeep(courseGroup)
        })

    }

    /**
     * 删除套餐详情的菜品
     */
    async handleDeleteDishes() {
        const { activeMenuIndex, courseGroup, deleteDishes } = this.state;
        // 套餐区域
        const activeMenu: CourseGroup | undefined = activeMenuIndex ? _.get(courseGroup, activeMenuIndex) : undefined;
        // 套餐详情
        const courseDetail = activeMenu?.course_detail || [];

        const result = await apiManage_rbp.delete_course_detail(deleteDishes.map((item) => item.id));
        // 重新排序要删除的菜品索引
        const newSortedIndex = deleteDishes.sort((a, b) => { return a.index - b.index })
        // 请求成功
        if (!_.get(result, 'error')) {
            for (let i = newSortedIndex.length - 1; i >= 0; i--) {
                courseDetail.splice(newSortedIndex[i].index, 1)
            }
            _.set(courseGroup, `${activeMenuIndex}.course_detail`, courseDetail)
            this.setState({
                rowsSelected: []
            })
        }
        else {
            GlobalNotification.error(i18n.t('google_text_delete_failed'))
        }

        this.setState({
            courseGroup
        })

    }

    /**
     * 保存套餐区域
     */
    async handleSave() {
        const { dishDetail } = this.props;
        const { activeMenuIndex, courseGroup } = this.state;
        const activeMenu: CourseGroup | undefined = activeMenuIndex ? _.get(courseGroup, activeMenuIndex) : undefined;

        if (activeMenu) {
            // 名称为空
            if (!_.trim(activeMenu?.course_group_name)) {
                return;
            }

            // 获取菜单里的菜品数量 暂时废弃以下判断模块
            // let count = 0
            // menuData.find(firstMenu => {
            //     // eslint-disable-next-line array-callback-return
            //     return (firstMenu.menu_item_slu || []).find(secondMenu => {
            //         if (secondMenu.dmi_slu_id === activeMenu.slu_id) {
            //             count = secondMenu.menu_item!.length
            //             return true
            //         }
            //     })
            // })

            // 校验必选满 暂时废弃以下判断模块
            // if (activeMenu.is_must) {
            //     const total = activeMenu.course_detail ? activeMenu.course_detail.reduce((res, item) => {
            //         res += item.num as number
            //         return res
            //     }, 0) : 0
            //     // 选了必选满  并且套餐区域的菜单菜品总数+下面新增套餐区域下的菜品数小于可选数量  则提示菜品数需要大于等于可选数量  不可保存
            //     if ((total + count as number) < (activeMenu.choose_num as number)) {
            //         GlobalNotification.error(i18n.t('menu_and_dishes_page_dish_num_must_over', { num: activeMenu.choose_num }))
            //         return
            //     }
            // }

            const params = {
                course_group_name: activeMenu.course_group_name,
                is_must: activeMenu.is_must,
                choose_num: activeMenu.choose_num,
                // slu_id: activeMenu.slu_id
            }
            const result = await apiManage_rbp.patch_course_group(
                dishDetail.item_id as number,
                activeMenu.course_group_id as number,
                params);

            const result2 = await apiManage_rbp.patchMenuItemFullSelect({
                course_group_id: activeMenu.course_group_id,
                is_full_select: activeMenu.is_full_select ? Number(activeMenu.is_full_select) : 0
            })
            // 请求成功
            if (!_.get(result, 'error') && !_.get(result2, 'error')) {
                GlobalNotification.success(i18n.t('google_text_public_text_save_successfully'));
                this.setState({
                    courseGroupSource: _.cloneDeep(courseGroup)
                })
            }
            else {
                GlobalNotification.error(i18n.t('global_save_text_failed'));
            }
        }
    }

    /**
     * 保存区域详情
     */
    async handleSaveDetail() {
        const { activeMenuIndex, courseGroup, detailIndex, courseGroupSource } = this.state;
        const activeMenu: CourseGroup | undefined = activeMenuIndex ? _.get(courseGroup, activeMenuIndex) : undefined;
        const detail: CourseDetail = _.get(activeMenu, `course_detail.[${detailIndex}]`)!;
        const { description, detail_id, item_course_name, menu_item_id, num, price, unit, rule_lnr_max_num } = detail
        const params = [{
            description,
            detail_id,
            item_course_name,
            menu_item_id,
            num,
            price,
            unit,
            rule_lnr_max_num,
        }];
        const result = await apiManage_rbp.patch_course_detail(
            activeMenu?.course_group_id as number,
            params
        )
        // 请求成功
        if (!_.get(result, 'error')) {
            GlobalNotification.success(i18n.t('google_text_public_text_save_successfully'));
            this.setState({
                courseGroupSource: _.cloneDeep(courseGroup),
                detailIndex: undefined,
                courseGroup: _.cloneDeep(courseGroup)
            })
        }
        else {
            GlobalNotification.error(i18n.t('global_save_text_failed'));
            this.setState({
                courseGroup: _.cloneDeep(courseGroupSource)
            })
        }
    }


    /**
     * 复制/转移
     */
    handleCourseGroup = async (dish: MenuDish[]) => {
        if (!dish.length) return GlobalNotification.error(i18n.t('expand_page_none_select'));
        const { handleCourseGroup, isDishDialogOpen } = this.state;
        const data: { course_id: number, course_group_id: number }[] = [];
        dish.forEach(item => {
            item.item_id && data.push({
                course_id: item.item_id,
                course_group_id: handleCourseGroup.course_group_id || -1
            })
        })
        let flag = false;
        if (isDishDialogOpen === 2) {
            const res = await apiManage_rbp.copy_course_detail(data);
            flag = !!_.get(res, 'error');
        } else {
            const res = await apiManage_rbp.transfer_course_detail(data);
            flag = !!_.get(res, 'error');
        }
        if (flag) {
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        } else {
            GlobalNotification.success(i18n.t('global_text_operate_success'))
            this.init()
        }
    }


    // *********************
    // View
    // *********************

    render() {
        const { deleteDishesDialogOpen, courseGroup, courseGroupSource, activeMenuIndex, isDishDialogOpen, detailIndex, deleteOpen, rowsPerPage, rowsSelected } = this.state;
        const { onCancel, open, menuData } = this.props;
        // 左侧菜单
        const menu = courseGroupSource.map((item) => ({
            key: `${item.course_group_id}`,
            title: item.course_group_name ?? '',
            dataSource: item,
        }))
        const activeMenu: CourseGroup | undefined = activeMenuIndex ? _.get(courseGroup, activeMenuIndex) : undefined;
        // 所有二级菜单
        const sluOptions: any[] = [{
            value: -1,
            label: i18n.t('menu_and_dishes_page_not_specified')
        }];
        menuData.forEach((item) => {
            item.menu_item_slu?.forEach((sluItem) => {

                sluOptions.push({
                    value: sluItem.dmi_slu_id,
                    label: sluItem.dmi_slu_name
                })
            })
        })

        // 表单
        const formArr = [
            {
                key: 'course_group_name',
                label: i18n.t('global_text_name'),
                regularType: 'required',
                require: true,
            },
            {
                key: 'is_must',
                label: i18n.t('message_notify_page_type'),
                regularType: 'required',
                require: true,
                type: 'select',
                select: true,
                items: [
                    {
                        value: 1,
                        label: i18n.t('menu_and_dishes_page_required')
                    },
                    {
                        value: 0,
                        label: i18n.t('menu_and_dishes_page_optional')
                    }
                ]
            },
            // 暂时不用此功能
            // {
            //     key: 'slu_id',
            //     label: i18n.t('menu_and_dishes_page_set_meal_area_menu'),
            //     type: 'select',
            //     select: true,
            //     items: sluOptions
            // },
            {
                hide: false,
                key: 'choose_num',
                label: i18n.t('menu_and_dishes_page_option_amount'),
                regularType: 'required',
                require: true,
                type: 'number',
            },
        ]

        const columns: MUIDataTableColumnDef[] = [
            {
                name: 'menu_item_id',
                label: i18n.t('google_text_id'),
            },
            {
                name: 'item_name1',
                label: i18n.t('global_text_name'),
            },
            {
                name: 'item_course_name',
                label: i18n.t('menu_and_dishes_page_dish_set_meal_name'),
            },
            {
                name: 'unit',
                label: i18n.t('menu_and_dishes_page_specification')
            },
            {
                name: 'num',
                label: i18n.t('menu_and_dishes_page_the_group_choose_number'),
            },
            {
                name: 'price',
                label: i18n.t('menu_and_dishes_page_price'),
            },
            {
                name: 'rule_lnr_max_num',
                label: i18n.t('menu_and_dishes_page_rule_lnr_max_num'),
            },
            {
                name: 'item_description',
                label: i18n.t('google_text_remark')
            },
            {
                name: 'action',
                label: i18n.t('google_text_check_detail'),
                options: {
                    sort: false,
                    download: false,
                    searchable: false,
                    customBodyRenderLite: (dataIndex: number) => {
                        return (
                            <ButtonComponent action='VIEW' handleClick={() => {
                                this.setState({
                                    detailIndex: dataIndex
                                })
                            }}>
                                <Visibility />
                            </ButtonComponent>
                        )
                    }
                }
            }
        ]

        const dishFormArr = [
            {
                key: 'menu_item_id',
                label: i18n.t('google_text_id'),
                disabled: true,
                width: 6 as const,
            },
            {
                key: 'item_name1',
                label: i18n.t('global_text_name'),
                disabled: true,
                width: 6 as const,
            },
            {
                key: 'item_course_name',
                label: i18n.t('menu_and_dishes_page_dish_set_meal_name'),
                width: 6 as const,
            },
            {
                key: 'unit',
                label: i18n.t('menu_and_dishes_page_specification'),
                disabled: true,
                width: 6 as const,
            },
            {
                key: 'num',
                label: i18n.t('menu_and_dishes_page_the_group_choose_number'),
                width: 6 as const,
                type: 'number',
            },
            {
                key: 'price',
                label: i18n.t('menu_and_dishes_page_price'),
                width: 6 as const,
                type: 'number',
            },
            {
                key: 'rule_lnr_max_num',
                label: i18n.t('menu_and_dishes_page_rule_lnr_max_num'),
                width: 6 as const,
                type: 'number',
            },
            {
                key: 'item_description',
                label: i18n.t('google_text_remark'),
                width: 12 as const,
                multiline: true,
            },
        ]

        return (
            <DialogComponent
                open={open}
                defaultHeaderProps={{
                    title: i18n.t('menu_and_dishes_page_menu_area_detail'),
                    onClose: onCancel,
                }}
            >
                <Box height={500}>
                    <Grid container spacing={6}>
                        <Grid item >
                            {/* 菜单列表 */}
                            <MenuListComponent
                                isHideSort={true}
                                isCourseGroup={true}
                                activeMenu={activeMenu ? `${activeMenu.course_group_id}` : undefined}
                                menu={menu}
                                handleClick={(menuData, index) => { this.handleClick(menuData, index) }}
                                handleMenuClick={(key, menu, index) => {
                                    this.handleMenuClick(key, menu, index)
                                }}
                            />

                        </Grid>
                        <Grid item xs={10}>
                            {
                                activeMenu &&
                                <div>
                                    <Card
                                        title={i18n.t('menu_and_dishes_page_basic_info')}
                                        contentRender={(
                                            <Grid container spacing={3}>
                                                {
                                                    formArr.map((item) => (
                                                        !item.hide ?
                                                            <Grid item xs={12} md={4} key={item.key}>
                                                                <CommonInput
                                                                    items={item.items}
                                                                    select={item.select}
                                                                    type={item.type}
                                                                    variant={'outlined'}
                                                                    fullWidth
                                                                    label={item.label}
                                                                    required={item.require}
                                                                    regularType={item.regularType}
                                                                    value={_.get(activeMenu, item.key) ?? ''}
                                                                    onChange={(event) => {
                                                                        const value = event.target.value;
                                                                        this.onChange(value, `${activeMenuIndex}.${item.key}`, item.key, activeMenu)
                                                                    }} />
                                                            </Grid>
                                                            :
                                                            null
                                                    ))
                                                }

                                            </Grid>
                                        )}
                                        actionRender={(
                                            <Box display={'flex'} alignItems={'center'}>
                                                {
                                                    activeMenu.is_must ?
                                                        <SwitchComponent
                                                            value={!!activeMenu.is_full_select}
                                                            label={i18n.t('menu_and_dishes_page_mandatory_full')}
                                                            onChange={async () => {
                                                                _.set(courseGroup, `${activeMenuIndex}.is_full_select`, !activeMenu.is_full_select)
                                                                this.setState({
                                                                    courseGroup,
                                                                })
                                                            }}
                                                        /> : null
                                                }

                                                <ButtonComponent
                                                    action='SAVE'
                                                    handleClick={() => { this.handleSave() }}
                                                />
                                            </Box>
                                        )}
                                    />
                                    <Box marginTop='8px'>
                                        {
                                            detailIndex || detailIndex === 0 ?
                                                <Card
                                                    title={(
                                                        <Box display='flex' alignItems='center'>
                                                            <ButtonComponent
                                                                action='BACK'
                                                                handleClick={() => {
                                                                    this.setState({
                                                                        detailIndex: undefined,
                                                                        courseGroup: _.cloneDeep(courseGroup)
                                                                    })
                                                                }}
                                                            />
                                                            <Typography>
                                                                {i18n.t('menu_and_dishes_page_edit_dish')}
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                    actionRender={(
                                                        <ButtonComponent
                                                            action='SAVE'
                                                            handleClick={() => { this.handleSaveDetail() }}
                                                        />
                                                    )}
                                                    contentRender={(
                                                        <Box marginTop='10px'>
                                                            <Grid container spacing={2} >
                                                                {
                                                                    dishFormArr.map((item) => (
                                                                        <Grid item xs={12} sm={item.width} key={item.key}>
                                                                            <CommonInput
                                                                                multiline={item.multiline}
                                                                                type={item.type}
                                                                                disabled={item.disabled}
                                                                                variant={'outlined'}
                                                                                fullWidth
                                                                                label={item.label}
                                                                                value={_.get(activeMenu, `course_detail.[${detailIndex}].${item.key}`) ?? ''}
                                                                                onChange={(event) => {
                                                                                    const value = event.target.value;
                                                                                    this.onChange(value, `${activeMenuIndex}.course_detail.[${detailIndex}].${item.key}`, item.key)
                                                                                }} />
                                                                        </Grid>
                                                                    ))
                                                                }

                                                            </Grid>
                                                        </Box>
                                                    )}

                                                />
                                                :
                                                <>
                                                    <ButtonComponent
                                                        action='ADD'
                                                        handleClick={() => {
                                                            this.setState({
                                                                isDishDialogOpen: 1
                                                            })
                                                        }}
                                                        buttonStyle={{ marginBottom: '8px' }}
                                                    />
                                                    <Table
                                                        title={i18n.t('menu_and_dishes_page_set_meal_area_dishes')}
                                                        data={activeMenu?.course_detail || []}
                                                        columns={columns}
                                                        rowsSelected={rowsSelected}
                                                        onRowSelectionChange={(currentRowsSelected: any[], allRowsSelected: any[], rowsSelected?: number[]) => {
                                                            this.setState({
                                                                rowsSelected: rowsSelected || []
                                                            })
                                                        }}
                                                        otherOption={{
                                                            viewColumns: true,
                                                            download: true,
                                                            downloadOptions: {
                                                                filename: _.get(courseGroup, `${activeMenuIndex}.course_group_name`) || ''
                                                            },
                                                            search: true,
                                                            pagination: true,
                                                            rowsPerPage,
                                                            onChangeRowsPerPage: (nums: number) => {
                                                                this.setState({
                                                                    rowsPerPage: nums,
                                                                })
                                                            },
                                                            selectableRowsHeader: true,
                                                            selectableRowsHideCheckboxes: false,
                                                            selectToolbarPlacement: 'replace',
                                                            onRowsDelete: (rowsDeleted: any) => {
                                                                this.setState({
                                                                    deleteDishesDialogOpen: true,
                                                                    deleteDishes: rowsDeleted.data.map((item: any) => ({
                                                                        id: _.get(activeMenu, `course_detail[${item.dataIndex}].detail_id`),
                                                                        index: item.dataIndex
                                                                    }))
                                                                })
                                                            },
                                                            page: this.state.currPage,
                                                            onChangePage: (page: number) => {
                                                                this.setState({ currPage: page })
                                                            },
                                                        }}
                                                    />
                                                </>
                                        }
                                    </Box>
                                </div>
                            }
                        </Grid>
                    </Grid>
                </Box>
                {
                    isDishDialogOpen ?
                        <MenuDishList
                            filterDishId={isDishDialogOpen === 1 ? this.props.dishDetail.item_id : undefined}
                            menuData={menuData}
                            dishGroupSelectedId={activeMenu?.slu_id}
                            open={isDishDialogOpen > 0}
                            onCancel={() => {
                                this.setState({
                                    isDishDialogOpen: 0
                                })
                            }}
                            isOnlyPackage={isDishDialogOpen !== 1}
                            isRadio={isDishDialogOpen === 3}
                            onConfirm={(ids, items) => {
                                const key = _.cloneDeep(isDishDialogOpen);
                                this.setState({
                                    isDishDialogOpen: 0
                                })
                                key === 1 ? this.addDish(items) : this.handleCourseGroup(items)
                            }}
                        />
                        :
                        <></>
                }
                {
                    deleteOpen &&
                    <AlertDialog
                        open={true}
                        variant="delete"
                        title={i18n.t('menu_and_dishes_page_delete_set_meal_area')}
                        onCancel={() => {
                            this.setState({
                                deleteOpen: false
                            })
                        }}
                        onConfirm={() => {
                            this.setState({
                                deleteOpen: false
                            }, () => {
                                this.handleDelete()
                            })

                        }}
                    />
                }
                {
                    deleteDishesDialogOpen &&
                    <AlertDialog
                        open={true}
                        variant="delete"
                        title={i18n.t('menu_and_dishes_page_delete_set_meal_area')}
                        onCancel={() => {
                            this.setState({
                                deleteDishesDialogOpen: false
                            })
                        }}
                        onConfirm={() => {
                            this.setState({
                                deleteDishesDialogOpen: false
                            }, () => {
                                this.handleDeleteDishes()
                            })

                        }}
                    />
                }


            </DialogComponent>
        )
    }
}

// *********************
// Type
// *********************
type Props = {
    // 开关
    open: boolean;
    // 取消
    onCancel: () => void;
    // 菜单源数据
    menuData: FirstMenu[];
    // 菜品详情
    dishDetail: MenuDish;
}
type State = {
    // 套餐区域数据
    courseGroup: CourseGroup[];
    // 套餐区域源数据
    courseGroupSource: CourseGroup[];
    // 当前选择的详情index
    activeMenuIndex: string;
    // 要删除的套餐区域id
    deleteItem?: {
        id: number;
        index: number;
    };
    // 菜品弹窗 0-关闭，1-新增 2-复制套餐组 3-转移套餐组
    isDishDialogOpen: number;
    // 显示菜品详情页面的index
    detailIndex?: number;
    // 加载中
    isLoading: boolean;
    // 删除确认框
    deleteOpen: boolean;
    // 删除套餐区域详情菜品的删除确认框
    deleteDishesDialogOpen: boolean;
    // 套餐详情选中的菜品id
    deleteDishes: {
        id: number;
        index: number;
    }[];
    // 表格显示行数
    rowsPerPage: number;
    // 当前页
    currPage: number;
    // 当前选中的菜品item
    rowsSelected: number[];
    // 待操作的套餐区域
    handleCourseGroup: CourseGroup;
}